import { gql } from 'apollo-boost';

export const servicesQuery = gql`
query {
  services {
    dbId
    name
    description
    version
  }
}
`;
